import { GetKitDto } from "./gen-api";

export const kitLabel = (kit: Pick<GetKitDto, "type">) => {
  let label = "Kit";
  switch (kit.type) {
    case "conversation":
      label = "Chat";
      break;
    case "interview":
      label = "Interview";
      break;
    case "skill":
      label = "Skill";
      break;
    case "template":
      label = "Template";
      break;
    case "expert":
      label = "Expert";
      break;
    case "project":
      label = "Workbook";
      break;
    case "project_preset":
      label = "Workbook template";
      break;
    case "repository":
      label = "Knowledge";
      break;
  }
  return label;
};
